import axios from "axios";
import { HoldingWithInstrumentAndAccount, Holding } from "../types";
import getServiceEndpoint from "./ServiceEndpoint";
import { buildClientHeader } from "./buildHeader";

export const getHoldings = async (
  fundId: number,
  reportingPeriodId?: number
): Promise<HoldingWithInstrumentAndAccount[]> => {
  try {
    // TODO - add reporting period!
    const response = await axios.get(
      `${getServiceEndpoint()}/holdings?fundId=${fundId}${
        reportingPeriodId ? `&reportingPeriodId=${reportingPeriodId}` : ""
      }`,
      buildClientHeader()
    );
    if (response.status !== 200 || response.data === undefined) {
      console.log("Failed to retrieve holdings", response.statusText);
      return [];
    }
    return response.data ?? [];
  } catch (error) {
    console.error("Error getting holdings:", error);
  }

  return [];
};

/**
 * Updates a holding with new values, including the isConfirmed status
 * @param holding - The holding object with updated values
 * @returns Promise resolving to the updated holding or null if update failed
 */
export const updateHolding = async (
  holding: Holding
): Promise<HoldingWithInstrumentAndAccount | null> => {
  try {
    const response = await axios.put(
      `${getServiceEndpoint()}/holdings`,
      JSON.stringify(holding),
      buildClientHeader()
    );
    if (response.status !== 200 || response.data === undefined) {
      console.log("Failed to update holding", response.statusText);
      return null;
    }
    return response.data;
  } catch (error) {
    console.error("Error updating holding:", error);
    return null;
  }
};

/**
 * Deletes a holding
 * @param holdingId - The ID of the holding to delete
 * @param reportingPeriodId - The reporting period ID
 * @returns Promise resolving to true if deletion was successful, false otherwise
 */
export const deleteHolding = async (
  holdingId: number,
  reportingPeriodId: number
): Promise<boolean> => {
  try {
    const response = await axios.delete(
      `${getServiceEndpoint()}/holdings?holdingId=${holdingId}&reportingPeriodId=${reportingPeriodId}`,
      buildClientHeader()
    );
    if (response.status === 200) {
      return true;
    }
    console.log("Failed to delete holding", response.statusText);
    return false;
  } catch (error) {
    console.error("Error deleting holding:", error);
    return false;
  }
};
